import { fromEntries } from '../../utils';
export function reset(state) {
    var _a = state ? state.tasks : { pending: {}, nextId: 1 }, pending = _a.pending, nextId = _a.nextId;
    return {
        data: {},
        tasks: {
            nextId: nextId,
            pending: {},
            pausedBy: {},
            queue: fromEntries(Object.keys(pending).map(function (key) { return [key, 'stop']; })),
        },
    };
}
//# sourceMappingURL=reset.js.map